import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../../../../../../redux/store";
import { useNavigate } from "react-router-dom";
import { deletePost, fetchPosts, upsertPost } from "../../../../../../../redux/blogSlice";

const AllPosts: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const posts = useSelector((state: RootState) => state.blog.posts);

  useEffect(() => {
    dispatch(fetchPosts());
  }, [dispatch]);

  const handleDelete = async (id: string) => {
    await dispatch(deletePost(id));
  };

  const handleDuplicate = async (post: any) => {
    const newPost = {
      ...post,
      id: undefined,
      title: post.title + " (Copy)",
      slug: post.slug + "-copy",
    };
    await dispatch(upsertPost(newPost));
  };

  const handleCopy = (slug: string) => {
    navigator.clipboard.writeText(`${window.location.origin}/${slug}`);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>All Posts</h2>
      <div style={styles.list}>
        {posts.map((post) => (
          <div key={post.id} style={styles.card}>
            <div style={styles.imageBox} onClick={() => navigate(`/editorial/posts/edit/${post.id}`)}>
              <img
                src={post.featuredImage || "/default-image.jpg"}
                alt="Cover"
                style={styles.img}
              />
            </div>
            <div style={styles.info}>
              <strong style={styles.title}>{post.title || "(no title)"}</strong>
              <div style={styles.actions}>
                <span style={styles.link} onClick={() => navigate(`/edit-post/${post.id}`)}>Edit</span>
                <span style={styles.link} onClick={() => handleDuplicate(post)}>Duplicate</span>
                <span style={styles.link} onClick={() => handleDelete(post.id)}>Trash</span>
                <span style={styles.link} onClick={() => window.open(`/${post.slug}`, "_blank")}>View</span>
                <span style={styles.link} onClick={() => handleCopy(post.slug)}>Copy link</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllPosts;

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    padding: "2rem",
    background: "linear-gradient(to bottom, #0a0014, #1e003a)",
    minHeight: "100vh",
    color: "#fff",
  },
  heading: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: "2rem",
  },
  list: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: 20,
  },
  card: {
    background: "#1a1a2f",
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 4px 14px rgba(0,0,0,0.2)",
  },
  imageBox: {
    cursor: "pointer",
  },
  img: {
    width: "100%",
    height: "180px",
    objectFit: "cover",
  },
  info: {
    padding: "1rem",
  },
  title: {
    display: "block",
    marginBottom: "1rem",
  },
  actions: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    fontSize: 13,
  },
  link: {
    color: "#a78bfa",
    cursor: "pointer",
    textDecoration: "underline",
  },
};
